/**
 * API client for report generation endpoints.
 * Routes: /api/mgmt/reports
 */

import { apiFetch } from './client';

export interface WeeklyReportPeriod {
  start: string;
  end: string;
  weekOffset: number;
}

export interface TopUser {
  user: string;
  spend: number;
}

export interface TopModel {
  model: string;
  spend: number;
}

export interface NewUser {
  username: string;
  email: string;
  createdAt: string;
}

export interface WeeklyReport {
  period: WeeklyReportPeriod;
  totalSpend: number;
  previousWeekSpend: number;
  spendChangePercent: number;
  totalRequests: number;
  totalTokens: number;
  topUsers: TopUser[];
  topModels: TopModel[];
  newUsers: NewUser[];
  newUsersCount: number;
}

export async function getWeeklyReport(token: string, weekOffset = 0): Promise<WeeklyReport> {
  const params = weekOffset > 0 ? `?weekOffset=${weekOffset}` : '';
  return apiFetch<WeeklyReport>(`/api/mgmt/reports/weekly${params}`, token);
}
